import { render, staticRenderFns } from "./InputSearchQuery.vue?vue&type=template&id=2b4e34f0&"
import script from "./InputSearchQuery.vue?vue&type=script&lang=js&"
export * from "./InputSearchQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports